
import React from 'react';
import createClass from 'create-react-class';
import PropTypes from 'prop-types';

import axios from 'axios';
import ReactFlagsSelect from 'react-flags-select';
import 'react-flags-select/css/react-flags-select.css';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { connect } from 'react-redux';
import SearchIcon from '../../image/search.png';
import { bindActionCreators } from 'redux';
import appActions from '../../redux/itunesSearch/actions';

import StyleWrapper from "./Wrapper";
import FlagStyleWrapper from './FlagWrapper';
import SelectStyleWrapper from './SelectWrapper';

import { FLAG_LABELS, COUNTRIES } from '../../constants/country';

const GravatarOption = createClass({
    propTypes: {
        children: PropTypes.node,
        className: PropTypes.string,
        isDisabled: PropTypes.bool,
        isFocused: PropTypes.bool,
        isSelected: PropTypes.bool,
        onFocus: PropTypes.func,
        onSelect: PropTypes.func,
        option: PropTypes.object.isRequired,
    },
    handleMouseDown (event) {
        event.preventDefault();
        event.stopPropagation();
        this.props.onSelect(this.props.option, event);
    },
    handleMouseEnter (event) {
        this.props.onFocus(this.props.option, event);
    },
    handleMouseMove (event) {
        if (this.props.isFocused) return;
        this.props.onFocus(this.props.option, event);
    },

    render () {      
        this.props.option.key < 4 && console.log(this.props.option);
        return (
            <div
                className={this.props.className}
                onMouseDown={this.handleMouseDown}
                onMouseEnter={this.handleMouseEnter}
                onMouseMove={this.handleMouseMove}
                title={this.props.option.title}>
                <img src={this.props.option.options.artworkUrl60} />
                <span className="app-name">{this.props.children}</span>
                <span className="owner">{this.props.option.options.sellerName}</span>
            </div>
          );
      }
  });

class SearchAppBar extends React.Component {
    constructor() {
      super();
      this.state = {
        redirectToReferrer: false,
        optionList : null,
      };
    }
  
    //TODO optionlist is missing
    onSelectAsyncChange = (app) => {
        this.setState({ value: app, });
        const { optionList, input } = this.state;
        console.log(app.value);
        console.log('optionList : ', optionList);
        console.log(this.props);

        if (optionList && optionList.length > 1) {
            this.props.appSelected(app.value , optionList[1].value);
            
            console.log(JSON.stringify(app.value));
            console.log(JSON.stringify(optionList[1].value));
        } else if (optionList && optionList.length === 1) {
            this.props.appSelected(app.value , app.value);
        } else { 
            this.props.appSelected(app.value , app.value); 
        }
        
        this.props.searchTermUpdated(input);
        
        if (this.props.auth && this.props.auth.isAuthenticated()) {
            this.props.goTo(`/addCampaign/appId/${app.value.adamId}`);
        } else { 
            this.props.goTo('/home'); 
        }
    };

    getApps = (input) => {
        if (!input) { return Promise.resolve({ options: [] }); }
        
        this.setState({ input });
        
        return axios.get(
            `https://itunes.apple.com/search`, {
                params: { term: input, country: this.props.countryCode || 'US' , entity: 'software', 'Authorization' : 'Bear xsjsjsjsjkss'}
            }
        )
            .then( (response) => {
                // console.log(response.data);
                if(response.data != undefined) {
                    // let itemData = response.data;
                    let itemData = response.data.results;
                    console.log(itemData);
                    
                    let items = itemData.map( (item, i) => { 
                        return {
                            key: i,
                            label: item.trackCensoredName,
                            id: i,
                            value: {
                                adamId: item.trackId,
                                bundleId: item.bundleId,
                                artworkUrl60: item.artworkUrl60,
                                artworkUrl100: item.artworkUrl100,
                                name: item.trackCensoredName,
                                trackCensoredName: item.trackCensoredName,
                                sellerName: item.sellerName,
                                screenshotUrls: item.screenshotUrls,
                            },
                            options: item
                        }
                    });
                    console.log( ' items ' , items );
                    
                    this.setState({ optionList: items });
                    return { options: items };
                }
            })
            .catch(error => { console.log(error.message); });
    };

    render() {
        return (
            <StyleWrapper className="search-app-bar">
                <div className="search-app-bar-border-wrapper">
                    <FlagStyleWrapper className="region-select">
                        <ReactFlagsSelect 
                            className="regionInput"
                            defaultCountry={this.props.countryCode ? this.props.countryCode.toUpperCase() : 'US'}
                            countries={COUNTRIES} 
                            customLabels={FLAG_LABELS} 
                            placeholder="Select Language" 
                            onSelect={this.props.onCountryCodeUpdated}
                            showSelectedLabel={true}
                        />
                    </FlagStyleWrapper>
                    
                    <SelectStyleWrapper className={`app-search ${ this.props.selectClassName }`}>
                        <Select.Async 
                            className={`searchInput ${ this.props.selectClassName }`}
                            multi={false}
                            value={this.props.value}
                            onChange={this.onSelectAsyncChange}
                            valueKey="value"
                            labelKey="label"
                            loadOptions={this.getApps}
                            placeholder={this.props.placeholder}
                            noResultsText="No search result"
                            backspaceRemoves={this.props.backspaceRemoves}
                            optionComponent={GravatarOption}
                        />
                    </SelectStyleWrapper>
                    <img src={process.env.PUBLIC_URL + SearchIcon}/>
                </div>
            </StyleWrapper>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return { 
        appSelected: bindActionCreators(appActions.appSelected, dispatch),
        searchTermUpdated:  bindActionCreators( appActions.searchTermUpdated, dispatch) ,
        onCountryCodeUpdated:  (countryCode) => dispatch(appActions.countryCodeUpdated(countryCode)) ,

    }
}
function mapStateToProps(state) {
    const campaign  = state.get('deep').campaign;
    return { 
        search: state.get('search'),
        campaign: campaign,
        currentApp: state.getIn( ['App', 'currentApp']),
        secondApp: state.getIn( ['App', 'secondApp']),
        searchTerm: state.getIn( ['App', 'searchTerm']),
        countryCode: state.getIn( ['ItunesSearch', 'countryCode']) || 'US',

    }
}
  
  
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SearchAppBar);
  


// WEBPACK FOOTER //
// ./src/components/SearchAppBar/index.js